import MatchesTable from './MatchesTable';

export default function SideBar() {
	return (
		<aside>
			<MatchesTable />
		</aside>
	);
}